/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDayAvailability200ResponseValueInner
 */
export interface GetDayAvailability200ResponseValueInner {
    /**
     * 
     * @type {string}
     * @memberof GetDayAvailability200ResponseValueInner
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof GetDayAvailability200ResponseValueInner
     */
    end: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDayAvailability200ResponseValueInner
     */
    available?: boolean;
}

/**
 * Check if a given object implements the GetDayAvailability200ResponseValueInner interface.
 */
export function instanceOfGetDayAvailability200ResponseValueInner(value: object): value is GetDayAvailability200ResponseValueInner {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    return true;
}

export function GetDayAvailability200ResponseValueInnerFromJSON(json: any): GetDayAvailability200ResponseValueInner {
    return GetDayAvailability200ResponseValueInnerFromJSONTyped(json, false);
}

export function GetDayAvailability200ResponseValueInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDayAvailability200ResponseValueInner {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'],
        'end': json['end'],
        'available': json['available'] == null ? undefined : json['available'],
    };
}

export function GetDayAvailability200ResponseValueInnerToJSON(json: any): GetDayAvailability200ResponseValueInner {
    return GetDayAvailability200ResponseValueInnerToJSONTyped(json, false);
}

export function GetDayAvailability200ResponseValueInnerToJSONTyped(value?: GetDayAvailability200ResponseValueInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'],
        'end': value['end'],
        'available': value['available'],
    };
}

